import { useCallback, useMemo } from 'react';

import { useNewAuth } from '@/providers/AuthProvider/NewAuthProvider.hooks';
import { ICtxEntity } from '@/providers/EntitiesListContextProvider/EntitiesListContext.types';

export const useEntitiesAccess = () => {
  const { user } = useNewAuth();

  const isLimited = Array.isArray(user?.trackedCounterparties);

  const allowedEntityValues = useMemo(() => {
    return new Set(user?.trackedCounterparties ?? []);
  }, [user?.trackedCounterparties]);

  const isEntityAllowed = useCallback(
    (entityValue: string) => !isLimited || allowedEntityValues.has(entityValue),
    [allowedEntityValues, isLimited],
  );

  const splitByAccess = useCallback(
    (entities: ICtxEntity[]) => {
      const allowed: ICtxEntity[] = [];
      const restricted: ICtxEntity[] = [];

      entities.forEach(entity =>
        isEntityAllowed(entity.value) ? allowed.push(entity) : restricted.push(entity),
      );

      return { allowed, restricted };
    },
    [isEntityAllowed],
  );

  return {
    isLimited,
    hasNoAllowedEntities: isLimited && allowedEntityValues.size === 0,
    isEntityAllowed,
    splitByAccess,
  };
};
